<button mat-icon-button class="dialog-close-btn" (click)="onClose()">
  <mat-icon>close</mat-icon>
</button>

<h2 mat-dialog-title class="modal-title">Reactivate Client</h2>

<form [formGroup]="reactivateForm" (ngSubmit)="onSubmit()" >

  <mat-dialog-content class="form-content">

    <!-- Row 1: Reactivation Date -->
    <div class="form-row">
      <div class="form-item">
        <app-data-picker
          [label]="'Reactivation Date'"
          [form]="reactivateForm"
          controlName="reactivationDate"
          [minDate]="minReactivationDate">
        </app-data-picker>
      </div>
    </div>

    <!-- Row 2: Comment (full width) -->
    <div class="form-item full-width">
      <mat-form-field appearance="outline" class="form-field full-width">
        <mat-label>Comment</mat-label>
        <textarea
          matInput
          formControlName="comment"
          placeholder="Add additional details about reactivation..."
          rows="4"></textarea>
      </mat-form-field>
    </div>

  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-actions">
    <app-form-actions-buttons [buttons]="submitButtons"></app-form-actions-buttons>
  </mat-dialog-actions>
</form>
